import replaceUrlToHttps from '../utils/replace-url-to-https';

/**
 * 获取默认分享参数
 * 注意: 必须在 https 环境下才可以生效
 * @return {{title: string, $link: string, imgUrl: string, desc: string}}
 */
export default function getDefaultShareParams() {
  const SHARE_IMG = `https://${DEPLOY_HTTP_URL}favicon-200x200.png`;
  return {
    title: '云水相逢_《剑网2》周年庆资料片！',
    $link: replaceUrlToHttps(window.location.href),
    imgUrl: SHARE_IMG,
    desc: '行千山万水，终与故人相逢！《剑网2》周年庆资料片9.24上线！',
    swapTitleInWX: false
  };
}
